import { BulkRetrieveFeatureSetStatusesRequest, BulkRetrieveFeatureStatusesRequest, FeaturamaServiceClientImpl } from '@squareup/shared-types-protos/squareup/featurama/service';
import rpcImpl from '../../utils/rpc';

const impl = rpcImpl();
export const featuramaClient = new FeaturamaServiceClientImpl(impl);

export const bulkRetrieveFeatureStatuses = async (params: BulkRetrieveFeatureStatusesRequest) => {
  const request = BulkRetrieveFeatureStatusesRequest.create(params);
  return featuramaClient.bulkRetrieveFeatureStatuses(request);
};

export const bulkRetrieveFeatureSetStatuses = async (params: BulkRetrieveFeatureSetStatusesRequest) => {
  const request = BulkRetrieveFeatureSetStatusesRequest.create(params);
  return featuramaClient.bulkRetrieveFeatureSetStatuses(request);
};
